// extracted by mini-css-extract-plugin
module.exports = {"offWhite":"#FFFEFB","container":"Nav-module--container--Njd8j","logo":"Nav-module--logo--2cPuV","link":"Nav-module--link--1GNVj"};